import AppController from "./controller/app-controller";
import CookieConsentConfig from "./utils/cookieconsent-config";
import { pushGoogleConsentUpdate, loadGtmWhenAllowed } from "./utils/consent-gtm";

/* Navigations / prefetch interrompus (Chrome) — bruit console, pas un bug app */
window.addEventListener("unhandledrejection", (event) => {
	const reason = event.reason;
	const msg = String(reason?.message || reason || "");
	if (reason?.name === "AbortError" || /Transition was skipped/i.test(msg)) {
		event.preventDefault();
	}
});

async function initCookieConsent() {
	const lang = document.documentElement.getAttribute("lang") || "fr";
	CookieConsentConfig.language.default = lang.split("-")[0];

	const CookieConsent = await import("vanilla-cookieconsent");
	window.CookieConsent = CookieConsent;

	const syncGoogleConsent = () => {
		pushGoogleConsentUpdate(CookieConsent.acceptedCategory("analytics"));
	};

	CookieConsentConfig.onFirstConsent = syncGoogleConsent;
	CookieConsentConfig.onConsent = syncGoogleConsent;
	CookieConsentConfig.onChange = syncGoogleConsent;

	await CookieConsent.run(CookieConsentConfig);
	syncGoogleConsent();
	/* Cookie déjà OK au boot head : re-garantir le load GTM si le head l’a raté */
	loadGtmWhenAllowed();
}

document.addEventListener("DOMContentLoaded", async function () {
	const app = new AppController();
	window.app = app;
	window.appController = app;

	/* Critique (loader / intro) d’abord */
	await app.ready;
	/* Barba / menu / Lenis / CF7 / cookies après reveal + idle */
	await app.deferredReady;
	await initCookieConsent();
});
